import React, { useState } from 'react';
import { priority, userCourse } from 'Constants/Database';
import useTranslation from 'Hooks/useTranslation';
import ModalDevelopment from '../Components/ModalDevelopment';
import { PRIORITY_ID } from 'Constants/priority';

/**
 * Hook para el modal de aprobación de cursos.
 * @param {Object} param0
 * @param {Function} param0.setOpen
 * @param {Function} param0.updateUserCourse
 * @returns {Object}
 * @returns {Function} selectModal
 */
const useModal = ({ setOpen, updateUserCourse }) => {
  const { t2 } = useTranslation('EmployeeAssess');
  const [isLoading, setIsLoading] = useState(false);

  const selectModal = course => {
    if (!course) {
      return null;
    }

    if (course.Course.Priority.id === PRIORITY_ID.normativa) {
      return (
        <ModalDevelopment
          title={t2('AssessCourse')}
          text={t2('NormativeMessage')}
          priorityType={priority.Normativa}
          close={() => setOpen(false)}
          button1Event={() => setOpen(false)}
        />
      );
    }
    if (course.Course.Priority.id === PRIORITY_ID.institucional) {
      return (
        <ModalDevelopment
          title={t2('AssessCourse')}
          text={t2('InstitutionalMessage')}
          priorityType={priority.Institucional}
          close={() => setOpen(false)}
          button1Event={async () => {
            await updateUserCourse('approve', null);
            setOpen(false);
          }}
          button2Event={() => setOpen(false)}
        />
      );
    }
    return (
      <ModalDevelopment
        title={t2('AssessCourse')}
        text={t2('TechnicalMessage')}
        priorityType={priority.Tecnica}
        close={() => setOpen(false)}
        button1Event={async file => {
          setIsLoading(true);
          updateUserCourse('approve', file);
          setIsLoading(false);
          setOpen(false);
        }}
        button2Event={() => setOpen(false)}
        isLoading={isLoading}
      />
    );
  };

  return {
    selectModal,
  };
};

export default useModal;
